import { useState } from "react";
import CompanyCard from "../_shared/CompanyCard/CompanyCard";
import { useCompanyPlan } from "./useCompanyPlan";
import { useCompanyForecastPlan } from "./useCompanyForecastPlan";
import CompanyCardPopup from "../_shared/CompanyCard/CompanyCardPopup";
import { useDashboard } from "../../../lib/useDashboard";
import CompanyPlanTrendPopup from "./CompanyPlanTrendPopup";
import { useIsMobile } from "@/shared/lib/useIsMobile";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/Auth/lib/useAuth';
import { canSeeCommercialOverview } from '@/features/Auth/lib/salesAccess';

function CompanyPlan() {
  const { profit, opportunity, loading, error } = useCompanyPlan();
  const forecast = useCompanyForecastPlan();
  const { dateStart, dateEnd } = useDashboard();
  const isMobile = useIsMobile();
  const [opportunityOpen, setOpportunityOpen] = useState(false);
  const [profitOpen, setProfitOpen] = useState(false);
  const [trendPopupOpen, setTrendPopupOpen] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();
  const openCompany = (fallback: () => void) => {
    if (!canSeeCommercialOverview(user) || !dateStart || !dateEnd) return fallback();
    const query = new URLSearchParams({ scope: 'company', dateStart, dateEnd });
    navigate(`/SalePlan/analytics?${query.toString()}`);
  };

  return (
    <>
      {/* <DashboardCard col={30} rowSpan={1} height={50} title="">
        <Button variant="secondary" size="s" onClick={() => setTrendPopupOpen(true)}>
          
        </Button>
      </DashboardCard> */}
      <CompanyPlanTrendPopup
        open={trendPopupOpen}
        onClose={() => setTrendPopupOpen(false)}
        dateStart={dateStart}
        dateEnd={dateEnd}
        currentOpportunity={opportunity.result ?? null}
        currentProfit={profit.result ?? null}
      />
      <>
        <CompanyCard
          title='План компании "Оборот"'
          col={30}
          row={isMobile ? 9 : 8}
          loading={loading}
          error={error}
          target={opportunity.result?.target}
          value={opportunity.result?.value}
          valuePreparation={opportunity.result?.valuePreparation ?? null}
          precent={opportunity.result?.precent}
          paid={opportunity.result?.paid}
          lastPeriod={opportunity.result?.lastPeriod}
          trend={opportunity.result?.trend}
          forecastValue={forecast.opportunity}
          plannedSalesValue={opportunity.result?.plannedSalesOpportunity ?? null}
          plannedSalesLabel="Плановые продажи, сумма"
          setOpenPopup={() => openCompany(() => setOpportunityOpen(true))}
        />
        <CompanyCardPopup
          open={opportunityOpen}
          onClose={() => setOpportunityOpen(false)}
          title='План компании "Оборот"'
          isPeriod={opportunity.isPeriod}
          setIsPeriod={opportunity.setIsPeriod}
        />
      </>

      <>
        <CompanyCard
          title='План компании "Валовая прибыль"'
          col={30}
          row={isMobile ? 9 : 7}
          loading={loading}
          error={error}
          target={profit.result?.target}
          value={profit.result?.value}
          valuePreparation={profit.result?.valuePreparation ?? null}
          precent={profit.result?.precent}
          lastPeriod={profit.result?.lastPeriod}
          trend={profit.result?.trend}
          forecastValue={forecast.profit}
          plannedSalesValue={profit.result?.plannedSalesProfit ?? null}
          plannedSalesLabel="Плановые продажи, прибыль"
          setOpenPopup={() => openCompany(() => setProfitOpen(true))}
        />
        <CompanyCardPopup
          open={profitOpen}
          onClose={() => setProfitOpen(false)}
          title='План компании "Валовая прибыль"'
          isPeriod={profit.isPeriod}
          setIsPeriod={profit.setIsPeriod}
        />
      </>

    </>
  );
}

export default CompanyPlan
